import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["text", "button"];

  copy() {
    let textToCopy;
    if (
      this.textTarget.tagName === "INPUT" ||
      this.textTarget.tagName === "TEXTAREA"
    ) {
      textToCopy = this.textTarget.value;
    } else {
      textToCopy = this.textTarget.textContent;
    }

    if (!navigator.clipboard) {
      console.error("Clipboard API not supported");
      return;
    }
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        this.buttonTarget.textContent = "Copied!";
        setTimeout(() => {
          this.buttonTarget.textContent = "Copy";
        }, 2000);
      })
      .catch((err) => {
        console.error("Failed to copy text:", err);
      });
  }
}
